/**
 * Armchair Epics - Order-Level Start Date Sync  v10
 *
 * Replaces IO's jQuery UI datepicker with a custom calendar we own.
 * IO's input stays in the DOM so Shopify still saves the cart property.
 * We hide it and write to it ourselves.
 */
(function () {
  'use strict';

  var STORAGE_KEY  = 'ae_start_date';
  var CART_ATTR    = 'Requested Start Date';
  var FIELD_SEL    = 'input[name="properties[Requested Start Date]"]';
  var DAYS_NOTICE  = 5;
  var PURPLE       = '#31154d';
  var CREAM        = '#faf6ec';

  var MONTHS = ['January','February','March','April','May','June',
                'July','August','September','October','November','December'];
  var DOW    = ['Su','Mo','Tu','We','Th','Fr','Sa'];

  /* -- Date helpers ----------------------------------------------- */

  function getMinDate() {
    var d = new Date();
    d.setHours(0, 0, 0, 0);
    d.setDate(d.getDate() + DAYS_NOTICE);
    return d;
  }

  function parseDate(str) {
    if (!str) return null;
    var d = new Date(str);
    if (!isNaN(d.getTime())) { d.setHours(0, 0, 0, 0); return d; }
    var m = str.match(/(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})/);
    if (m) { d = new Date(+m[3], +m[1] - 1, +m[2]); }
    if (!isNaN(d.getTime())) { d.setHours(0, 0, 0, 0); return d; }
    return null;
  }

  function snapToMailingDate(date) {
    var min   = getMinDate();
    var start = date > min ? new Date(date) : new Date(min);
    var y = start.getFullYear(), mo = start.getMonth();
    for (var i = 0; i < 24; i++) {
      var mm  = (mo + i) % 12;
      var yy  = y + Math.floor((mo + i) / 12);
      var d1  = new Date(yy, mm, 1);
      var d15 = new Date(yy, mm, 15);
      if (d1  >= start) return d1;
      if (d15 >= start) return d15;
    }
    return null;
  }

  function formatDate(d) {
    return d
      ? d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })
      : '';
  }

  function sameDay(a, b) {
    return a && b &&
      a.getFullYear() === b.getFullYear() &&
      a.getMonth()    === b.getMonth()    &&
      a.getDate()     === b.getDate();
  }

  /* -- Cart sync -------------------------------------------------- */

  function syncCart(val) {
    var payload = { attributes: {} };
    payload.attributes[CART_ATTR] = val;
    fetch('/cart/update.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify(payload)
    }).catch(function () {});
  }

  /* -- Write to readonly IO input --------------------------------- */

  function setIO(input, val) {
    var desc = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
    desc.set.call(input, val);
    input.dispatchEvent(new Event('input',  { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* -- Notice ----------------------------------------------------- */

  function renderNotice(anchor, dateStr) {
    var n = document.getElementById('ae-start-date-notice');
    if (!n) {
      n = document.createElement('p');
      n.id        = 'ae-start-date-notice';
      n.className = 'ae-start-date-notice';
      anchor.insertAdjacentElement('afterend', n);
    }
    n.innerHTML = dateStr
      ? '<span class="ae-start-date-notice__icon">&#10022;</span>' +
        '<span><strong>' + dateStr + '</strong> is your start date &mdash; ' +
        'it applies to every series in your order. ' +
        'Change it to update for all items.</span>'
      : '<span class="ae-start-date-notice__icon">&#10022;</span>' +
        '<span>Your start date applies to <strong>all series in your order</strong>. ' +
        'Letters go out on the <strong>1st &amp; 15th</strong> &mdash; ' +
        'pick any date and we\'ll confirm your nearest mailing date.</span>';
  }

  /* -- Styles ----------------------------------------------------- */

  function injectStyles() {
    if (document.getElementById('ae-dp-css')) return;
    var s = document.createElement('style');
    s.id = 'ae-dp-css';
    var BG    = '#faf6ec';  /* --ae-cream */
    var INK   = '#1a1330';  /* --ae-ink   */
    var TAUPE = 'rgba(106,100,128,.6)';

    s.textContent = [
      '#ae-datepicker{position:relative;display:block;margin-bottom:8px}',

      /* Trigger - identical to IO input field */
      '.ae-dp-trigger{display:flex;align-items:center;justify-content:space-between;',
        'width:100%;padding:13px 16px;background:' + BG + ';',
        'border:1px solid rgba(44,81,128,.18);border-radius:3px;cursor:pointer;',
        'font-size:17px;font-family:inherit;color:' + INK + ';',
        'text-align:left;box-sizing:border-box}',
      '.ae-dp-trigger:hover{border-color:rgba(44,81,128,.35)}',
      '.ae-dp-trigger--set{color:' + PURPLE + ';border-color:rgba(49,21,77,.35)}',
      '.ae-dp-trigger-caret{font-size:9px;opacity:.35;margin-left:8px;flex-shrink:0}',

      /* Dropdown panel */
      '.ae-dp-panel{position:absolute;left:0;right:0;z-index:9999;',
        'background:' + BG + ';border:1px solid rgba(49,21,77,.25);border-radius:6px;',
        'box-shadow:0 4px 6px -1px rgba(30,26,20,.08),0 28px 60px -24px rgba(30,26,20,.55);',
        'overflow:hidden;margin-top:4px;box-sizing:border-box}',

      /* Header - cream background, dark text */
      '.ae-dp-header{display:flex;align-items:center;justify-content:space-between;',
        'background:transparent;padding:14px 18px 8px}',
      '.ae-dp-title{flex:1;text-align:center;font-style:italic;font-size:19px;',
        'color:' + INK + ';font-family:inherit;white-space:nowrap;line-height:1}',
      '.ae-dp-title em{font-style:italic}',
      '.ae-dp-title span{font-style:normal;color:' + TAUPE + '}',
      '.ae-dp-arrow{background:transparent;border:none;cursor:pointer;font-size:20px;',
        'line-height:1;color:' + PURPLE + ';padding:4px 8px;border-radius:3px;',
        'font-family:inherit;display:flex;align-items:center;justify-content:center;',
        'opacity:.8}',
      '.ae-dp-arrow:hover:not([disabled]){background:rgba(49,21,77,.1);opacity:1}',
      '.ae-dp-arrow[disabled]{opacity:.2;cursor:default}',

      /* Calendar body */
      '.ae-dp-grid{display:grid;grid-template-columns:repeat(7,1fr);',
        'padding:10px 12px 14px;gap:0}',
      '.ae-dp-dow{text-align:center;font-family:"Jost",sans-serif;font-size:10px;',
        'font-weight:500;letter-spacing:.18em;text-transform:uppercase;',
        'color:' + TAUPE + ';padding:10px 0 6px}',
      '.ae-dp-blank{}',

      /* Day buttons */
      '.ae-dp-day{background:transparent;border:2px solid transparent;border-radius:50%;',
        'cursor:pointer;font-size:16px;width:36px;height:36px;display:flex;align-items:center;',
        'justify-content:center;font-family:inherit;box-sizing:border-box;margin:2px auto;',
        'color:' + INK + ';transition:background .15s,color .15s}',
      '.ae-dp-day:hover:not([disabled]){background:rgba(49,21,77,.1)}',

      /* Disabled */
      '.ae-dp-day--off{opacity:.25!important;cursor:default!important;pointer-events:none!important}',

      /* Mailing dates - purple outline circle */
      '.ae-dp-day--mail{color:' + PURPLE + ';font-weight:600;border-color:' + PURPLE + '}',
      '.ae-dp-day--mail:hover:not([disabled]){background:rgba(49,21,77,.1)}',

      /* Selected - filled purple */
      '.ae-dp-day--sel{background:' + PURPLE + '!important;color:' + BG + '!important;',
        'border-color:' + PURPLE + '!important;font-weight:600}',
    ].join('');
    document.head.appendChild(s);
  }

  /* -- Build one month into the grid ----------------------------- */

  function buildMonth(grid, vy, vm, minDate, selDate, onPick) {
    grid.innerHTML = '';

    DOW.forEach(function (d) {
      var h = document.createElement('div');
      h.className = 'ae-dp-dow';
      h.textContent = d;
      grid.appendChild(h);
    });

    var firstDow    = new Date(vy, vm, 1).getDay();
    var daysInMonth = new Date(vy, vm + 1, 0).getDate();

    for (var b = 0; b < firstDow; b++) {
      grid.appendChild(document.createElement('div'));
    }

    for (var d = 1; d <= daysInMonth; d++) {
      var date = new Date(vy, vm, d);
      var btn  = document.createElement('button');
      btn.type      = 'button';
      btn.className = 'ae-dp-day';
      btn.textContent = String(d);

      var mail = (d === 1 || d === 15) && date >= minDate;
      var off  = !mail;
      var sel  = selDate && sameDay(date, selDate);

      if (off)  { btn.classList.add('ae-dp-day--off'); btn.disabled = true; }
      if (mail) { btn.classList.add('ae-dp-day--mail'); }
      if (sel)  { btn.classList.add('ae-dp-day--sel'); }

      if (!off) {
        (function (dt) {
          btn.addEventListener('click', function () { onPick(dt); });
        })(date);
      }

      grid.appendChild(btn);
    }
  }

  /* -- Create the widget ------------------------------------------ */

  function createWidget(ioInput, onSelect) {

    /* 1. Kill IO's jQuery UI datepicker */
    try {
      if (window.jQuery && jQuery.fn && jQuery.fn.datepicker) {
        jQuery(ioInput).datepicker('destroy');
      }
    } catch (e) {}

    /* 2. Hide IO's input but keep it in the DOM (Shopify reads it for the order) */
    ioInput.setAttribute('style',
      'position:absolute;opacity:0;pointer-events:none;width:1px;height:1px;');
    ioInput.addEventListener('focus', function (e) {
      e.stopImmediatePropagation();
    }, true);

    /* 3. Build DOM */
    var wrap = document.createElement('div');
    wrap.id  = 'ae-datepicker';

    /* Trigger */
    var trigger = document.createElement('button');
    trigger.type      = 'button';
    trigger.className = 'ae-dp-trigger';
    var triggerText = document.createElement('span');
    triggerText.textContent = 'Choose a start date';
    var caret = document.createElement('span');
    caret.className = 'ae-dp-trigger-caret';
    caret.innerHTML = '&#9660;';
    trigger.appendChild(triggerText);
    trigger.appendChild(caret);

    /* Panel */
    var panel = document.createElement('div');
    panel.className = 'ae-dp-panel';
    panel.hidden    = true;

    /* Header */
    var hdr = document.createElement('div');
    hdr.className = 'ae-dp-header';

    var prev = document.createElement('button');
    prev.type      = 'button';
    prev.className = 'ae-dp-arrow';
    prev.innerHTML = '&#8592;';          /* left arrow via HTML entity */
    prev.setAttribute('aria-label', 'Previous month');

    var titleEl = document.createElement('span');
    titleEl.className = 'ae-dp-title';

    var next = document.createElement('button');
    next.type      = 'button';
    next.className = 'ae-dp-arrow';
    next.innerHTML = '&#8594;';          /* right arrow via HTML entity */
    next.setAttribute('aria-label', 'Next month');

    hdr.appendChild(prev);
    hdr.appendChild(titleEl);
    hdr.appendChild(next);

    var grid = document.createElement('div');
    grid.className = 'ae-dp-grid';

    panel.appendChild(hdr);
    panel.appendChild(grid);
    wrap.appendChild(trigger);
    wrap.appendChild(panel);

    ioInput.parentNode.insertBefore(wrap, ioInput);

    /* 4. State */
    var viewYear, viewMonth, selDate = null;

    (function initView() {
      var min = getMinDate();
      viewYear  = min.getFullYear();
      viewMonth = min.getMonth();
      /* Advance if neither mailing date this month is reachable */
      if (new Date(viewYear, viewMonth, 15) < min) {
        viewMonth++;
        if (viewMonth > 11) { viewMonth = 0; viewYear++; }
      }
    })();

    /* 5. Render */
    function render() {
      var min = getMinDate();

      titleEl.innerHTML = '<em>' + MONTHS[viewMonth] + '</em> <span>' + viewYear + '</span>';

      /* Disable prev if previous month has no reachable mailing date */
      var pm = viewMonth === 0 ? 11 : viewMonth - 1;
      var py = viewMonth === 0 ? viewYear - 1 : viewYear;
      prev.disabled = new Date(py, pm, 15) < min;

      buildMonth(grid, viewYear, viewMonth, min, selDate, function onPick(rawDate) {
        var snapped = snapToMailingDate(rawDate);
        if (!snapped) return;
        selDate   = snapped;
        viewYear  = snapped.getFullYear();
        viewMonth = snapped.getMonth();
        render();

        var display = formatDate(snapped);
        triggerText.textContent = display;
        trigger.classList.add('ae-dp-trigger--set');
        panel.hidden = true;

        onSelect(snapped, display);
      });
    }

    /* 6. Navigation */
    prev.addEventListener('click', function (e) {
      e.stopPropagation();
      viewMonth--;
      if (viewMonth < 0) { viewMonth = 11; viewYear--; }
      render();
    });

    next.addEventListener('click', function (e) {
      e.stopPropagation();
      viewMonth++;
      if (viewMonth > 11) { viewMonth = 0; viewYear++; }
      render();
    });

    /* 7. Open / close */
    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      if (panel.hidden) { render(); panel.hidden = false; }
      else panel.hidden = true;
    });

    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) panel.hidden = true;
    });

    /* 8. Public API */
    return {
      setDate: function (date, display) {
        selDate   = date;
        viewYear  = date.getFullYear();
        viewMonth = date.getMonth();
        triggerText.textContent = display;
        trigger.classList.add('ae-dp-trigger--set');
      }
    };
  }

  /* -- Bootstrap -------------------------------------------------- */

  function init(ioInput) {
    injectStyles();

    /* Validate + load stored date */
    var stored     = localStorage.getItem(STORAGE_KEY);
    var storedDate = stored ? parseDate(stored) : null;
    if (stored && !storedDate) {
      localStorage.removeItem(STORAGE_KEY);
      stored = null;
    }

    var widget  = createWidget(ioInput, function (snapped, display) {
      localStorage.setItem(STORAGE_KEY, display);
      setIO(ioInput, display);
      syncCart(display);
      renderNotice(document.getElementById('ae-datepicker'), display);
    });

    var wrapper = document.getElementById('ae-datepicker');

    if (stored && storedDate) {
      widget.setDate(storedDate, stored);
      setIO(ioInput, stored);
      syncCart(stored);
      renderNotice(wrapper, stored);
    } else {
      renderNotice(wrapper, null);
    }
  }

  function waitForIO() {
    var el = document.querySelector(FIELD_SEL);
    if (el) { init(el); return; }
    var obs = new MutationObserver(function (_, self) {
      var el = document.querySelector(FIELD_SEL);
      if (!el) return;
      self.disconnect();
      init(el);
    });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForIO);
  } else {
    waitForIO();
  }

}());